module.exports = window.__federationLoadRemote("moduleCreative");